import { createReducer, on } from '@ngrx/store';
import * as CurrentOrganizationActions from '../actions/current-organization.actions';
import {Organization} from '../../../services/api/organizations/models/organization.model';

export const currentOrganizationFeatureKey = 'currentOrganization';

export interface State {
  record: Organization;
  error: any | null;
  loaded: boolean;
  loading: boolean;
}

export const initialState: State = {
  record: null,
  error: null,
  loaded: false,
  loading: false,
};


export const reducer = createReducer(
  initialState,

  on(CurrentOrganizationActions.loadCurrentOrganization, (state: State): State => ({
    ...state,
    error: null,
    loaded: false,
    loading: true,
  })),
  on(CurrentOrganizationActions.loadCurrentOrganizationSuccess, (_state: State, action: {data: Organization}): State => ({
    record: action.data,
    error: null,
    loaded: true,
    loading: false,
  })),
  on(CurrentOrganizationActions.loadCurrentOrganizationFailure, (_state: State, action: {error: unknown}): State => ({
    record: null,
    error: action.error,
    loaded: false,
    loading: false,
  })),
  on(CurrentOrganizationActions.clearCurrentOrganizationState, (): State => ({
    record: null,
    error: null,
    loaded: false,
    loading: false,
  })),
);
